/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".blue-gradient[_ngcontent-%COMP%]{background:linear-gradient(40deg,#45cafc,#4285f4)}"];
export { styles as styles };
